import React, { Component } from 'react';
import PageHeader from '../PageHeader';
import DottedLines from './DottedLines';

export default class Reflection extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {step, subTitle} = this.props;
    let questions;
    if (step === '4') {
      questions = [
        'What possible reasons can you think of for the variations in the rating on the statements above?',
        'How do the variations above compare with the other information in this report?'
      ]
    } else {
      questions = [
        'Based on this chart, what appear to be your strongest and least strong capability areas?',
        'How does this align with your self perceptions?',
        'Which capabilities may be the most relevant for you to look into further?'
      ]
    }
    return (
      <div className='bg-white page-break user-report__content'>
        <PageHeader h2Class='mt4' h2Text='Part 1: ' strong={`Step ${step}`} h3Text={subTitle} line={true} />
        <div className='mb3'>
          <h3 className='f5 gray mt2'>Reflection</h3>
          {questions.map((question, i) => {
            return (
              // <>
              <div key={i}>
                <p>{question}</p>
                <DottedLines numberOfLines={6} />
              {/* </> */}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

